<div class="market-table">
  <app-data-table class="data-table" [columnDefs]="columnDefs" [rows]="marketData" [showPagination]="false" [stickyHeader]="true"></app-data-table>
<!--  <table width="100%" border="1" cellpadding="4">-->
<!--    <thead>-->
<!--      <tr>-->
<!--        <th *ngFor="let column of columnDefs">{{column.label}}</th>-->
<!--      </tr>-->
<!--    </thead>-->
<!--    <tbody>-->
<!--     <tr *ngFor="let item of marketData">-->
<!--       <td *ngFor="let column of columnDefs">{{item[column.field]}}</td>-->
<!--     </tr>-->
<!--    </tbody>-->
<!--  </table>-->
</div>
